import { useState } from "react";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { downloadInstallationScheduleKpi } from "../../api/schedules";
import { useGroupListHooks } from "../../utils/ProjectsUtilHooks";
import AlertBox from "../AlertBox";

function getDefaultFilter() {
  return {
    survey_status: "",
    project_id: "",
    date_from: moment().subtract(3, "months").format("YYYY-MM-DD"),
    date_until: moment().format("YYYY-MM-DD"),
  };
}

export default function ModalDownloadInstallationKpi({ show, onClose, onSuccess }) {
  const [formFilter, setFormFilter] = useState(getDefaultFilter);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [loading, setLoading] = useState(false);
  const { projects } = useGroupListHooks();

  const handleClose = () => {
    setFormFilter(getDefaultFilter());
    setAlert({ show: false, message: "", type: "" });
    onClose();
  };

  const downloadFile = async () => {
    setLoading(true);
    setAlert({ show: false, message: "", type: "" });

    try {
      const response = await downloadInstallationScheduleKpi({ ...formFilter });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Data KPI Instalasi.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      onSuccess("Berhasil mengunduh Data KPI Instalasi.xlsx");
      handleClose();
    } catch (error) {
      let message = "Something Error Happened";

      try {
        const responseData = error.response?.data;
        const errorData =
          responseData instanceof Blob ? JSON.parse(await responseData.text()) : responseData;
        message = errorData?.message || message;
      } catch {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message, type: "danger" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Download KPI Instalasi</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertBox {...alert} setAlert={setAlert} />
        <div className="form-group">
          <label htmlFor="download-installation-kpi-status">Status</label>
          <select
            id="download-installation-kpi-status"
            className="form-control"
            value={formFilter.survey_status}
            onChange={(event) => setFormFilter({ ...formFilter, survey_status: event.target.value })}
            disabled={loading}
          >
            <option value="">SEMUA</option>
            <option value="survey-uninstallable">Sudah Survey - Ditolak</option>
            <option value="survey-canceled">Sudah Survey - Dibatalkan</option>
            <option value="survey-unpaid">Sudah Survey - Belum Bayar</option>
            <option value="survey-paid">Sudah Survey - Siap Pasang</option>
            <option value="survey-installed">Sudah Survey - Sudah Dipasang</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="download-installation-kpi-project">Project/Site</label>
          <select
            id="download-installation-kpi-project"
            className="form-control"
            value={formFilter.project_id}
            onChange={(event) => setFormFilter({ ...formFilter, project_id: event.target.value })}
            disabled={loading}
          >
            <option value="">SEMUA</option>
            {projects.map((project) => (
              <option value={project.id} key={project.id}>
                {project.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="download-installation-kpi-date-from">Tanggal Dari</label>
          <input
            type="date"
            id="download-installation-kpi-date-from"
            className="form-control"
            value={formFilter.date_from}
            onChange={(event) => setFormFilter({ ...formFilter, date_from: event.target.value })}
            disabled={loading}
          />
        </div>
        <div className="form-group">
          <label htmlFor="download-installation-kpi-date-until">Tanggal Sampai</label>
          <input
            type="date"
            id="download-installation-kpi-date-until"
            className="form-control"
            value={formFilter.date_until}
            onChange={(event) => setFormFilter({ ...formFilter, date_until: event.target.value })}
            disabled={loading}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={handleClose}>
          Close
        </button>
        <button type="button" className="btn btn-primary" onClick={downloadFile} disabled={loading}>
          <i className="fas fa-download" aria-hidden="true"></i>{" "}
          {loading ? "Harap Tunggu ..." : "Unduh Data"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
